<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} proforma
            <span *ngIf="isEdit">| {{item.value.nro_voucher}}</span>
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="preSubmit()" autocomplete="off">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-6">
                  <label id="client_label">Cliente responsable <span class="required"></span>
                    <div class="book__nrodoc m-l-20" *ngIf="clientSelected != null">
                      ( {{clientSelected.typeDocument}} : {{clientSelected.document}} )
                    </div>
                  </label>
                  <ng-container *ngIf="clientSelected != null">
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm" disabled
                        value="{{clientSelected.fullname}}">
                      <div class="input-group-append bg-custom b-0 removeClient">
                        <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                          (click)="removeClient()">
                          <i class="fas fa-backspace w-100 f-s-12"></i>
                        </div>
                        <div class="input-group-text bg-info w-100 text-center text-white pointer p-l-10"
                          data-toggle="modal" data-target="#openExtendsClient"
                          (click)="ClientExtendsComponent.editClient(clientSelected.id)">
                          <i class="far fas fa-pen-alt w-100 f-s-12"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="clientSelected == null">
                    <div class="input-group input-group-grid">
                      <component-search-client [classSize]="'search-small'"
                        (selectedClientEvent)="selectedClientSearch($event)" class="w-100">
                      </component-search-client>
                      <div class="input-group-append b-0">
                        <div class="input-group-text w-100 text-center pointer p-l-10" data-toggle="modal"
                          data-target="#openExtendsClient" (click)="ClientExtendsComponent.loadData()">
                          <i class="fas fa-user-plus w-100"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="form-group col-lg-3">
                  <label>Fecha emisión <span class="required"></span></label>
                  <input type="date" id="date_issue" placeholder="Selecciona fecha" class="form-control"
                    formControlName="date_issue">
                </div>
                <div class="form-group col-lg-3">
                  <label>Fecha vencimiento <span class="required"></span></label>
                  <input type="date" id="date_expiration" placeholder="Selecciona fecha" class="form-control"
                    formControlName="date_expiration">
                </div>
                <div class="form-group col-lg-3">
                  <label>N° celular <span class="required"></span></label>
                  <input id="cellphone" type="text" class="form-control" formControlName="cellphone" maxlength="20"
                    ng-required="true">
                </div>
                <div class="form-group col-lg-3">
                  <label>Correo electrónico</label>
                  <input type="email" class="form-control" formControlName="email">
                </div>
                <div class="form-group col-lg-6">
                  <label>Dirección</label>
                  <input type="text" class="form-control" formControlName="address">
                </div>
                <div class="form-group col-lg-6">
                  <label>Observaciones</label>
                  <textarea class="form-control no-resize" formControlName="observation" rows="1"></textarea>
                </div>

                <div class="form-group col-lg-3">
                  <label>Cuenta para depósito
                    <span class="f-s-9" *ngIf="accountbanks.length == 0">( 0 registros )</span>
                  </label>
                  <ng-container *ngIf="accountbanks.length == 0">
                    <a type="button" class="btn btn-outline-info"
                      routerLink="/{{branchofficeSlug}}/finanzas/cuentas_bancarias/lista">
                      <i class="fas fa-arrow-right m-r-5"></i>Agregar Cuenta
                    </a>
                  </ng-container>
                  <ng-container *ngIf="accountbanks.length > 0">
                    <select class="form-control" id="bankAccountSelected" (change)="changeBankAccount($event.target)">
                      <option *ngIf="!isEdit" value="null">Seleccionar cuenta</option>
                      <option *ngFor="let item of accountbanks" [value]="item.id">{{ item.concat_description}}
                      </option>
                    </select>
                  </ng-container>
                </div>
              </div>
            </div>

            <div class="col-lg-12 m-t-10 form__contentTbl">
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-lg-2 col-12">
                      <p class="form__group__title f-s-14"> <i class="fa fa-cart-plus m-r-5"></i>Lista items</p>
                    </div>
                    <div class="col-lg-6 col-12">
                      <component-search-product [searchAll]="true" placeholderText="Buscar producto/servicio"
                        (selectedProductEvent)="selectedProductSearch($event)">
                      </component-search-product>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0 table-sm">
                  <thead class="thead-default">
                    <tr>
                      <th>Nombre producto</th>
                      <th class="text-center w-15">U. Medida</th>
                      <th class="text-right w-10">
                        P.V <span data-toggle="tooltip" data-placement="right" data-original-title="Precio de venta"
                          title=""><i class="fas fa-info-circle m-l-5"></i></span>
                      </th>
                      <th class="text-right w-10">Cantidad</th>
                      <!-- <th class="text-right w-10">IGV</th> -->
                      <th class="text-right W-10">SubTotal</th>
                      <th class="w-5 text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="products.length == 0">
                      <tr>
                        <td colspan="4"><span>Aun no se han agregado items</span></td>
                      </tr>
                    </ng-container>
                    <ng-container *ngIf="products.length > 0">
                      <tr *ngFor="let item of products; let index_ = index">
                        <td>
                          {{item.description}}
                        </td>
                        <td class="text-center w-15">
                          <select class="form-control form-control-sm" id="unitSelected{{index_}}"
                            (change)="changeUnitSelected($event.target,index_, item)">
                            <ng-container *ngFor="let unit of item.unitsmeasure">
                              <ng-container *ngIf="item.unit_id == unit.id">
                                <option value="{{unit.id}}" selected="true">
                                  {{unit.description}} ({{unit.equivalence}})</option>
                              </ng-container>
                              <ng-container *ngIf="item.unit_id != unit.id">
                                <option value="{{unit.id}}">
                                  {{unit.description}} ({{unit.equivalence}})</option>
                              </ng-container>
                            </ng-container>
                          </select>
                        </td>

                        <td class="w-10">
                          <input type="text" id="price{{index_}}" class="form-control sale__input text-right"
                            value="{{item.price}}" (keyup)="changePrice($event.target, index_)" numeric decimals="2"
                            onclick="click_input(this)">
                        </td>
                        <td class="w-10">
                          <input type="text" id="quantity{{index_}}" class="form-control sale__input text-right"
                            value="{{item.quantity}}" (keyup)="changeQuantity($event.target, index_)" numeric
                            onclick="click_input(this)">
                        </td>
                        <!-- <td class="w-10">
                          <input type="text" id="igv[[$index]]" name="igv[]" allow-only-decimals ng-value="item.igv"
                            ng-model="igv_" ng-disabled="proforma.is_igv == false"
                            ng-change="recalculate_igv(igv_, item, $index)" ng-click="click_input_igv(this)"
                            class="form-control form-control-sm text-right">

                        </td> -->
                        <td class="text-right W-10">
                          <span class="bold">{{currencySelected.symbol}}{{item.subtotal}}</span>
                        </td>
                        <td class="w-5 text-center">
                          <i class="far fa-trash-alt pointer f-s-15 text-danger"
                            (click)="removeProduct(item.id, index_)"></i>
                        </td>
                      </tr>
                    </ng-container>

                  </tbody>
                </table>
              </div>
            </div>

            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-9"></div>
                <div class="col-lg-3" *ngIf="currencySelected != null">
                  <div class="row m-b-15">
                    <div class="col-6">Subtotal</div>
                    <div class="col-6 text-right">{{currencySelected.symbol}}{{subtotal}}</div>
                  </div>
                  <!-- <div class="row m-b-15">
                    <div class="col-6">IGV ({{igv}} %)</div>
                    <div class="col-6 text-right">{{total_igv | currency: currencySelected.symbol}}</div>
                  </div> -->
                  <div class="row">
                    <div class="col-6"><span class="text-primary bold">TOTAL</span></div>
                    <div class="col-6 text-right">
                      <span class="text-primary bold">{{currencySelected.symbol}}{{total_proforma}}</span>
                    </div>
                  </div>

                </div>
              </div>
            </div>


            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar Recibido
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<app-client-extends (onSubmitEvent)="extendsClient($event)"></app-client-extends>
